var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 54,
    viewBox: "0 0 250 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130.000000, -73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FF6154",
    strokeWidth: 1,
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 249,
    height: 53,
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#FF6154"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 53,
    y: 20
  }, "#2 PRODUCT OF THE WEEK")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#FF6154"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 52,
    y: 40
  }, "Marketing")), "\n        false\n        ", /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,15.5 C31,24.0603917 24.0603917,31 15.5,31 C6.93960833,31 0,24.0603917 0,15.5 C0,6.93960833 6.93960833,0 15.5,0 C24.0603917,0 31,6.93960833 31,15.5",
    fill: "#FF6154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4329412,15.9558824 L17.4329412,15.9560115 L13.0929412,15.9560115 L13.0929412,11.3060115 L17.4329412,11.3060115 L17.4329412,11.3058824 C18.7018806,11.3058824 19.7305882,12.3468365 19.7305882,13.6308824 C19.7305882,14.9149282 18.7018806,15.9558824 17.4329412,15.9558824 M17.4329412,8.20588235 L17.4329412,8.20601152 L10.0294118,8.20588235 L10.0294118,23.7058824 L13.0929412,23.7058824 L13.0929412,19.0560115 L17.4329412,19.0560115 L17.4329412,19.0558824 C20.3938424,19.0558824 22.7941176,16.6270324 22.7941176,13.6308824 C22.7941176,10.6347324 20.3938424,8.20588235 17.4329412,8.20588235",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.e9b0b9686f720ad9e3ade8b69846a983.svg";
export { ForwardRef as ReactComponent };